import DateWidget from './dateWidget';
import OauthWidget from './oauthWidget';
import GAQueryBuilder from '@components/sources/source/singerSource/GAQLQueryBuilder';

export default {
  date: DateWidget,
  Oauth: OauthWidget,
  GAQueryBuilder,
};
